<template>
        <div class="tip pt10 pl10 pr10 pb10">
            <el-row>
                <el-col :span="2">
                    <i class="el-icon-bell fs20"></i>
                </el-col>
                <el-col :span="22">
                    {{content}}
                </el-col>
            </el-row>
        </div>
</template>

<script>
    export default {
        name: "hos-tip",
        props:{
            content:{
                type:String,
                default:"如果有资料需要补充，请在通过图片或添加附件的方式补充，补充完成后，点击右侧的确定上传按钮，接受医生就能看到啦！如有还有疑问可以点击页面上方的帮助手册！"
            }
        }
    }
</script>

<style lang="scss" scoped>
.tip{
    line-height: 20px;
    border: 1px dashed #19B8AF;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #19B8AF;
}
</style>